/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import * as Ui from './styles';

const propTypes = {
  title: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  onClick: PropTypes.func,
  subItens: PropTypes.array,
};

const defaultProps = {
  title: 'Menu item',
  icon: null,
  onClick: null,
  subItens: [],
};

export default function MenuItem(props) {
  const { title, icon, onClick, subItens, color, padding, disabled, tooltip, theme } = props;
  const Icon = icon;

  function handleItemClick(e) {
    if (onClick) onClick(e);
  }

  return (
    <>
      {/* menu items */}
      <Ui.MenuItem
        className="menuItem"
        tabIndex={-999}
        role="button"
        onClick={disabled ? null : handleItemClick}
        onKeyDown={disabled ? null : handleItemClick}
        padding={padding || '18px 20px'}
        color={color}
        disabled={disabled}
        data-tip
        data-for={tooltip ? 'tooltip' : ''}
      >
        <Ui.IconStyleWrapper>
          <Icon className="icon" />
        </Ui.IconStyleWrapper>
        {title}
        {/* Tooltip */}
        {tooltip && (
          <ReactTooltip id="tooltip" place="right" effect="float" arrowColor={theme.colors.tooltipBorderColor}>
            {tooltip}
          </ReactTooltip>
        )}
      </Ui.MenuItem>
      {/* sub menu items */}
      {(subItens.map((item, i) => (
        <Ui.MenuItem
          key={item.key}
          className="subMenuItem"
          tabIndex={-999}
          role="button"
          onClick={disabled ? null : item.onClick}
          onKeyDown={disabled ? null : item.onClick}
          padding="10px 20px 10px 40px"
          disabled={disabled}
          data-tip
          data-for={tooltip ? 'tooltip' : ''}
        >
          <Ui.IconStyleWrapper>
            <item.icon className="icon" itemIcon={item.icon} />
          </Ui.IconStyleWrapper>
          {item.title}
        </Ui.MenuItem>
      )))}
    </>
  );
}

MenuItem.propTypes = propTypes;

MenuItem.defaultProps = defaultProps;
